module.exports = __webpack_public_path__ + "875fd9ee66956a1f20b2dc66a8f2ac45.pdf";